import React from 'react';
import { RedoOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import { Tooltip, Button } from 'antd';
import { openMarketFinderSearchFromAssistantText } from '../../utils/teamAssistantMarketFinderSearch';

const TeamAssistantMessageExtraActions = ({
  message,
  isLastAssistant,
  streaming,
  onAskAgain,
  onRegenerate,
  className = '',
}) => {
  const numericId =
    message?.id && !String(message.id).startsWith('temp-') ? Number(message.id) : null;

  if (message.role === 'user') {
    const text = (message.content || '').trim();
    if (!text) return null;
    return (
      <Tooltip title="Ask again — put this question in the composer">
        <Button
          type="text"
          size="small"
          className={`message-copy-share-actions-btn ${className}`.trim()}
          icon={<EditOutlined />}
          disabled={streaming}
          aria-label="Ask again"
          onClick={() => onAskAgain?.(message)}
        />
      </Tooltip>
    );
  }

  if (message.role === 'assistant') {
    const text = (message.content || '').trim();
    return (
      <>
        {text && (
          <Tooltip title="Open Market Finder search from this reply (new tab)">
            <Button
              type="text"
              size="small"
              className={`message-copy-share-actions-btn ${className}`.trim()}
              icon={<SearchOutlined />}
              disabled={streaming}
              aria-label="Search in Market Finder"
              onClick={() => openMarketFinderSearchFromAssistantText(text)}
            />
          </Tooltip>
        )}
        {isLastAssistant && numericId ? (
          <Tooltip title="Regenerate reply">
            <Button
              type="text"
              size="small"
              className={`message-copy-share-actions-btn ${className}`.trim()}
              icon={<RedoOutlined />}
              disabled={streaming}
              aria-label="Regenerate reply"
              onClick={() => onRegenerate?.(message)}
            />
          </Tooltip>
        ) : null}
      </>
    );
  }

  return null;
};

export default TeamAssistantMessageExtraActions;
